import clsx from 'clsx';
import { ROUTES } from '../../shared/config/routes';
import logo from '../../shared/assets/images/logo.svg';
import { LogoutIcon } from '../../shared/ui/icons';
import { IconButton } from '../../shared/ui/icon-button/IconButton';
import styles from './TopBar.module.css';
import { RouteTabSwitcher } from './RouteTabSwitcher';

export function TopBar({ userName = '', tenantName = '', onLogout }) {
  const tabs = [
    { label: 'Templates', to: ROUTES.TEMPLATES },
    { label: 'Campaigns', to: ROUTES.CAMPAIGNS },
  ];

  return (
    <header className={clsx(styles.topBar)}>
      <div className={clsx(styles.left)}>
        <img className={clsx(styles.logo)} src={logo} alt="Waythru" />
        <RouteTabSwitcher items={tabs} ariaLabel="Primary" />
      </div>

      <div className={clsx(styles.right)}>
        <div className={clsx(styles.account)}>
          {tenantName ? <span>{tenantName}</span> : null}
          {tenantName && userName ? (
            <span className={clsx(styles.accountDivider)} aria-hidden />
          ) : null}
          {userName ? <span>{userName}</span> : null}
          <IconButton
            className={clsx(styles.logoutButton)}
            onClick={onLogout}
            ariaLabel="Log out"
            size="md"
          >
            <LogoutIcon />
          </IconButton>
        </div>
      </div>
    </header>
  );
}
